import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DeleteIcon from "../../../Assets/svg/deletelogo.svg";
import { notes, notesData, notesFormik, resType } from "../../../../../Types";
import { useFormik } from "formik";
import axiosClientInterceptors from "../../../../ApiConfig/axiosClientInterceptor";
import { AxiosResponse } from "axios";
import Loader from "../../../../Tools/Loader";
import SmallLoader from "../../../../Tools/SmallLoader";
import { validateActivityStatus } from "../../../../Tools/Validation";
import { Toaster } from "../../../../Tools/Toaster";

const NoteType = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDel, setOpenDel] = useState<boolean>(false);
  const [notes, setNotes] = useState<notes[]>([]);
  const [notesData, setNotesData] = useState<notesData>({
    section_name: "",
    _id: "",
  });
  const [noteID, setNoteID] = useState<string>("");
  const [loader, setLoader] = useState<boolean>(false);
  const [addLoader, setAddLoader] = useState<boolean>(false);
  const [editLoader, setEditLoader] = useState<boolean>(false);
  const [delLoader, setDelLoader] = useState<boolean>(false);

  const addNotesFormik = useFormik<notesFormik>({
    initialValues: {
      projectStatus: "",
    },
    validationSchema: validateActivityStatus,
    onSubmit: (val) => {
      setAddLoader(true);
      axiosClientInterceptors
        .post(`/config/general`, {
          section_heading: "Note Type",
          section_name: val.projectStatus,
        })
        .then((res: AxiosResponse) => {
          const data: resType = res.data;
          if (data?.success) {
            getNotesType();
            setOpen(false);
            addNotesFormik.resetForm({});
            Toaster("success", data?.message);
            setAddLoader(false);
          } else {
            Toaster("error", data?.message);
          }
        })
        .catch((err: AxiosResponse) => {
          console.log(err);
          setAddLoader(false);
        });
    },
  });

  const editNoteFormik = useFormik<notesFormik>({
    enableReinitialize: true,
    initialValues: {
      projectStatus: notesData.section_name,
    },
    validationSchema: validateActivityStatus,
    onSubmit: (val) => {
      setEditLoader(true);
      axiosClientInterceptors
        .put(`/config/general/${notesData._id}`, {
          section_name: val.projectStatus,
        })
        .then((res: AxiosResponse) => {
          const data: resType = res.data;
          if (data?.success) {
            getNotesType();
            setOpenEdit(false);
            setEditLoader(false);
            Toaster("success", data?.message);
            editNoteFormik.resetForm({});
          } else {
            Toaster("error", data?.message);
            setEditLoader(false);
          }
        })
        .catch((err: AxiosResponse) => {
          console.log(err);
          setEditLoader(false);
        });
    },
  });

  const deleteNote = () => {
    setDelLoader(true);
    axiosClientInterceptors
      .delete(`/config/general/${noteID}`)
      .then((res: AxiosResponse) => {
        const data: resType = res.data;
        if (data?.success) {
          getNotesType();
          setOpenDel(false);
          setDelLoader(false);
        }
      })
      .catch((err: AxiosResponse) => {
        console.log(err);
        setDelLoader(false);
      });
  };

  const getNotesType = () => {
    setLoader(true);
    axiosClientInterceptors
      .get(`/config/general/Note Type`)
      .then((res: AxiosResponse) => {
        setNotes(res.data?.result);
        setLoader(false);
      })
      .catch((err: AxiosResponse) => {
        console.log(err);
        setLoader(false);
      });
  };

  useEffect(() => {
    getNotesType();
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center h-[68px] p-6">
        <p className="project_Heading">Note Type</p>
        <button
          className="addstatus_btn"
          onClick={() => {
            setOpen(true);
          }}
        >
          {" "}
          <AddIcon sx={{ fontSize: "18px", marginBottom: "2px" }} /> Add Note
        </button>
      </div>
      {loader ? (
        <Loader customHeight={"30vh"} />
      ) : (
        <>
          {notes?.map((item, i) => (
            <>
              <div className="flex justify-between items-center p-6 h-[55px] border-t-[2px] border-t-[#F5F8FA]">
                <p className="content_title">{item?.section_name}</p>
                <div className="flex gap-5">
                  <button
                    className="edit_stuts"
                    onClick={() => {
                      setNotesData(item);
                      setOpenEdit(true);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete_status"
                    onClick={() => {
                      setNoteID(item?._id);
                      setOpenDel(true);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </>
          ))}
        </>
      )}

      {/* Add Note type pop starts */}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          addNotesFormik.resetForm({});
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "386px",
              minHeight: "230px",
            },
          },
        }}
      >
        <div className="p-5">
          <div className="flex justify-between">
            <p className="font-[Gm] font-semibold text-[18px] text-[#000000]">
              Add New Note Type
            </p>
            <CloseRoundedIcon
              className="cursor-pointer"
              onClick={() => {
                setOpen(false);
                addNotesFormik.resetForm({});
              }}
            />
          </div>
          <form action="" onSubmit={addNotesFormik.handleSubmit}>
            <div className="mt-4">
              <div>
                <label
                  htmlFor=""
                  className="font-[Gm] font-medium text-[13px] text-[#221E1F]"
                >
                  Task Name
                </label>
                <input
                  type="text"
                  name="projectStatus"
                  placeholder="Enter Task Name"
                  className="add_input mt-3 w-full"
                  onChange={addNotesFormik.handleChange}
                />
                {addNotesFormik.touched.projectStatus &&
                  addNotesFormik.errors.projectStatus && (
                    <p className="required_message">
                      {addNotesFormik.errors.projectStatus}
                    </p>
                  )}
              </div>
              <button
                type="submit"
                disabled={addLoader}
                className="input_btn mt-4 w-full"
              >
                {addLoader ? <SmallLoader color="" /> : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Dialog>
      {/* Add Note type pop ends */}

      {/* Edit Note type pop ends */}
      <Dialog
        open={openEdit}
        onClose={() => {
          setOpenEdit(false);
          editNoteFormik.resetForm({});
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "386px",
              minHeight: "230px",
            },
          },
        }}
      >
        <div className="p-5">
          <div className="flex justify-between">
            <p className="font-[Gm] font-semibold text-[18px] text-[#000000]">
              Edit Note Type
            </p>
            <CloseRoundedIcon
              className="cursor-pointer"
              onClick={() => {
                setOpenEdit(false);
                editNoteFormik.resetForm({});
              }}
            />
          </div>
          <form onSubmit={editNoteFormik.handleSubmit}>
            <div className="mt-4">
              <div>
                <label
                  htmlFor=""
                  className="font-[Gm] font-medium text-[13px] text-[#221E1F]"
                >
                  Task Name
                </label>
                <input
                  name="projectStatus"
                  type="text"
                  placeholder="Enter Task Name"
                  className="add_input mt-3 w-full"
                  defaultValue={notesData.section_name}
                  onChange={editNoteFormik.handleChange}
                />
                {editNoteFormik.touched.projectStatus &&
                  editNoteFormik.errors.projectStatus && (
                    <p className="required_message">
                      {editNoteFormik.errors.projectStatus}
                    </p>
                  )}
              </div>
              <button
                disabled={editLoader}
                type="submit"
                className="input_btn mt-4 w-full"
              >
                {editLoader ? <SmallLoader color="" /> : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Dialog>
      {/* Edit Note type pop starts */}

      {/* delete pop starts */}
      <Dialog
        open={openDel}
        onClose={() => {
          setOpenDel(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "404px",
              height: "265px",
            },
          },
        }}
      >
        <div className="p-5">
          <div className="flex justify-center items-center">
            <img
              style={{
                width: "80px",
              }}
              src={DeleteIcon}
              alt=""
            />
          </div>
          <div className="deleteText mt-6">
            Are you sure want to Delete this Status
          </div>
          <div className="flex justify-between items-center mt-9">
            <button
              className="cancelDelUser"
              onClick={() => {
                setOpenDel(false);
              }}
            >
              Cancel
            </button>
            <button
              className="delUser"
              onClick={() => {
                deleteNote();
              }}
            >
              {delLoader ? <SmallLoader color="" /> : "Delete"}
            </button>
          </div>
        </div>
      </Dialog>
      {/* delete pop ends */}
    </div>
  );
};

export default NoteType;
